module.exports = __webpack_public_path__ + "static/graham-e5ae4ce8814697d88a33b066948ddf14.gif";